const DROPDOWN_MAX_HEIGHT = 400;
const VIEWPORT_GAP = 12;
const TRIGGER_GAP = 4;
const SPINNER_MIN_VISIBLE_DURATION = 700;

// Выбирает сторону открытия и доступную высоту dropdown-а.
export function getBaseSelectDropdownPosition({
  triggerRect,
  viewport,
  inlineSearch = false,
}) {
  const triggerGap = TRIGGER_GAP;
  const spaceBelow = viewport.bottom - triggerRect.bottom;
  const spaceAbove = triggerRect.top - viewport.top;
  const openUpward =
    !inlineSearch &&
    spaceBelow < DROPDOWN_MAX_HEIGHT &&
    spaceAbove > spaceBelow;
  const availableHeight = Math.max(
    0,
    (openUpward ? spaceAbove : spaceBelow) - VIEWPORT_GAP - triggerGap
  );
  const maxHeight = Math.min(DROPDOWN_MAX_HEIGHT, availableHeight);

  return {
    openUpward,
    verticalAnchor: openUpward ? "bottom" : "top",
    triggerGap,
    maxHeight,
  };
}

// Empty state зависит не только от количества options: пустой результат уже
// выполненного поиска должен сообщать результат поиска, а не состояние списка
// до ввода query.
export function getBaseSelectEmptyStateText({
  optionsCount,
  searchPerformed,
  noResultsText,
  inlineSearch,
  autoSearch,
}) {
  if (searchPerformed) return noResultsText;
  if (optionsCount === 0 || inlineSearch) return "Список пуст";
  if (autoSearch) return "Введите поисковый запрос";

  return "Введите поисковый запрос и нажмите 'Найти'";
}

// Мобильная клавиатура может держать composition-сессию до закрытия клавиатуры.
// В этот момент Vue еще не обязан обновить v-model, но нативный input уже
// содержит полный query. Берем его напрямую, чтобы debounce не ждал blur.
export function getBaseSelectSearchQuery(event, currentQuery) {
  return event?.target?.value ?? currentQuery;
}

// Быстрый ответ не должен превращать spinner в незаметное мигание. Возвращаем
// только оставшееся время одного оборота, чтобы BaseSelect не задерживал
// обновление результатов, а задерживал лишь возврат иконки лупы.
export function getBaseSelectSpinnerHideDelay({ startedAt, currentTime }) {
  return Math.max(
    0,
    SPINNER_MIN_VISIBLE_DURATION - (currentTime - startedAt)
  );
}

// Debounce нужен только перед HTTP-запросом. Локальная фильтрация работает с
// уже полученными options и должна обновлять список на каждый символ без паузы.
export function shouldDebounceBaseSelectSearch({
  externalSearch,
  autoSearch,
}) {
  return externalSearch && autoSearch;
}

// Одинаковый query не требует нового HTTP-запроса, пока пользователь не
// выполнил явное действие, например не нажал Enter.
export function shouldEmitBaseSelectSearch({
  query,
  lastQuery,
  force,
}) {
  return force || query !== lastQuery;
}

// При сужении модалки BaseSelect с width: 100% меняет собственный размер вместе
// с ближайшим layout-контейнером. Этого достаточно для пересчета позиции и не
// дает ResizeObserver затронуть дальних предков других селектов на странице.
export function getBaseSelectResizeObserverTargets(root) {
  return [root, root.parentElement].filter(Boolean);
}
